import { schema } from 'normalizr';

const domainGroup = new schema.Entity( 'domainGroups' );

export const domainGroupSchema = domainGroup;
export const domainGroupsSchema = [ domainGroup ];
